module.exports = __webpack_public_path__ + "static/media/drugn-wallet.9550ea63.png";